
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Jogeshwaritopunecab() {



    const cardData =
    {
        keyword: 'Jogeshwari to Pune Cab Service',
        heading: 'Skyline Cabs: Jogeshwari to Pune Cab Service',
        headingDescription: 'Skyline Cabs offers reliable and affordable Jogeshwari to Pune Cab Service for a comfortable and stress-free journey. Whether you are traveling for business, family visits, or a weekend getaway, our professional drivers and well-maintained vehicles ensure a smooth ride. With on-time pickups from Jogeshwari, transparent pricing, and 24/7 customer support, Skyline Cabs makes your intercity travel between Jogeshwari and Pune convenient and hassle-free. Book your cab today and enjoy a safe and comfortable journey with Skyline Cabs.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Jogeshwari to Pune Taxi Fare",
      "description": "Skyline Cabs offers reliable and affordable taxi services for journeys from Jogeshwari to Pune. Our transparent pricing includes all charges such as tolls, fuel, and driver fees, ensuring no hidden costs. Choose from a range of vehicles including sedans, Ertiga, and Innova Crysta."
    },
    {
      "name": "Jogeshwari to Pimpri Chinchwad Cab Service",
      "description": "Travel comfortably from Jogeshwari to Pimpri Chinchwad with Skyline Cabs. We offer reliable taxi services with experienced drivers and a variety of vehicles like Ertiga, Innova Crysta, and sedans for your convenience."
    },
    {
      "name": "Jogeshwari to Pune One Way Cab",
      "description": "Book a one-way cab from Jogeshwari to Pune with Skyline Cabs for a hassle-free journey. Enjoy affordable pricing and a smooth ride with options like Innova Crysta, Ertiga, and other reliable vehicles for your convenience."
    },
    {
      "name": "Jogeshwari to Pune Round Trip Cab",
      "description": "Skyline Cabs provides round-trip taxi services from Jogeshwari to Pune, allowing you to book your return trip in advance. We offer a variety of vehicles and competitive pricing, ensuring you a comfortable journey both ways."
    },
    {
      "name": "Cab Service in Jogeshwari",
      "description": "Looking for a reliable cab service in Jogeshwari? Skyline Cabs offers local and outstation taxi services with professional drivers and well-maintained vehicles. We offer a range of options including SUVs, sedans, and luxury vehicles."
    },
    {
      "name": "Ertiga in Jogeshwari Mumbai",
      "description": "Skyline Cabs offers Ertiga on rent for travel within Jogeshwari and outstation trips. Book your ride today for a comfortable and spacious journey with friends or family, ensuring a smooth and pleasant ride to your destination."
    },
    {
      "name": "Innova Crysta on Rent in Jogeshwari Mumbai",
      "description": "Book the luxury Innova Crysta for your journey from Jogeshwari with Skyline Cabs. Whether it’s a local trip or an outstation journey, enjoy premium comfort and ample space with experienced chauffeurs at your service."
    },
    {
      "name": "Jogeshwari to Pune Sedan Cab Fare",
      "description": "Skyline Cabs offers affordable sedan cab services from Jogeshwari to Pune. Our fares are transparent and competitive, ensuring that you get the best deal for your one-way or round-trip journey."
    },
    {
      "name": "Outstation Cabs in Jogeshwari West",
      "description": "Skyline Cabs offers outstation cab services from Jogeshwari West to destinations like Pune, Nashik, and beyond. With well-maintained vehicles and experienced drivers, we provide a seamless travel experience."
    },
    {
      "name": "Jogeshwari East Cab Service",
      "description": "Skyline Cabs provides reliable cab services in Jogeshwari East, offering both local and outstation trips. Choose from a variety of vehicles including Innova Crysta, Ertiga, and sedans for a comfortable journey."
    },
    {
      "name": "Lokhandwala Complex to Pune Cab",
      "description": "Book a cab from Lokhandwala Complex to Pune with Skyline Cabs for a smooth and timely journey. Our services include experienced drivers, well-maintained vehicles, and affordable pricing for your convenience."
    },
    {
      "name": "Cab Service in Jogeshwari Mumbai",
      "description": "Skyline Cabs provides taxi services in Jogeshwari Mumbai for both local and outstation travel. We ensure punctual pick-ups, experienced drivers, and a variety of vehicle options to suit your preferences."
    },
    {
      "name": "Cab Service in Jogeshwari West",
      "description": "Travel comfortably with Skyline Cabs offering cab services in Jogeshwari West. Whether it's a short ride or a long-distance trip, we have options for you to choose from, including sedans, SUVs, and luxury vehicles."
    },
    {
      "name": "Cab Booking Mumbai",
      "description": "Booking a cab in Mumbai is easy with Skyline Cabs. Whether you need a taxi for a local ride, outstation trip, or airport transfer, our simple online booking process ensures a hassle-free experience with guaranteed reliability."
    },
    {
      "name": "Mumbai Taxi Service",
      "description": "Skyline Cabs offers top-rated taxi services across Mumbai. Our fleet of well-maintained vehicles, including sedans, Ertiga, and Innova Crysta, ensures a comfortable and reliable ride to any destination in and around Mumbai."
    },
    {
      "name": "Cheapest Cab Service in Mumbai",
      "description": "Skyline Cabs offers the most affordable taxi services in Mumbai without compromising on quality. We provide competitive pricing for local and outstation travel, ensuring that you get the best value for your money."
    },
    {
      "name": "Cab Service Jogeshwari",
      "description": "Skyline Cabs offers premium cab services in Jogeshwari for local and outstation travel. Our services are tailored to meet your needs, with options for one-way, round-trip, and daily commute bookings."
    },
    {
      "name": "Outstation Cab Service in Mumbai",
      "description": "Traveling outstation from Mumbai? Skyline Cabs offers convenient outstation cab services with competitive pricing. Choose from our fleet of comfortable vehicles like sedans, Ertiga, and Innova Crysta for a smooth ride."
    }
  ],
  "tableData": [
    ["Jogeshwari to Pune Taxi Fare", "Jogeshwari to Pimpri Chinchwad Cab Service"],
    ["Jogeshwari to Pune One Way Cab", "Jogeshwari to Pune Round Trip Cab"],
    ["Cab Service in Jogeshwari", "Ertiga in Jogeshwari Mumbai"],
    ["Innova Crysta on Rent in Jogeshwari Mumbai", "Jogeshwari to Pune Sedan Cab Fare"],
    ["Outstation Cabs in Jogeshwari West", "Jogeshwari East Cab Service"],
    ["Lokhandwala Complex to Pune Cab", "Cab Service in Jogeshwari Mumbai"],
    ["Cab Service in Jogeshwari West", "Cab Booking Mumbai"],
    ["Mumbai Taxi Service", "Cheapest Cab Service in Mumbai"],
    ["Cab Service Jogeshwari", "Outstation Cab Service in Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Jogeshwari to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and efficient cab services from Jogeshwari to Pune. Whether you're traveling for work, leisure, or a special occasion, our service ensures a smooth, timely, and comfortable ride every time."
    },
    {
        "WhyChooseheading": "Comfortable, Well-Maintained Vehicles",
        "WhyChoosedescription": "We offer a fleet of well-maintained vehicles, including sedans, SUVs, and luxury cars, to ensure that your journey from Jogeshwari to Pune is as comfortable as possible. Each vehicle is air-conditioned, spacious, and equipped with all the necessary amenities for a pleasant ride."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe Travel",
        "WhyChoosedescription": "Our drivers are highly experienced, trained, and familiar with the best routes from Jogeshwari to Pune. They are dedicated to providing a safe, efficient, and pleasant journey, ensuring that you arrive on time and in comfort."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Skyline Cabs offers competitive, transparent pricing for your Jogeshwari to Pune journey. There are no hidden charges, and the fare is always clear upfront, so you can enjoy peace of mind knowing that you’re paying a fair and affordable rate."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel",
        "WhyChoosedescription": "Whether you need a ride early in the morning or late at night, Skyline Cabs is available around the clock. Our 24/7 service ensures that you can book a cab from Jogeshwari to Pune at your convenience, no matter the time."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your Jogeshwari to Pune cab is quick and easy with Skyline Cabs. Use our website or mobile app to book your ride in minutes, with instant confirmation and the option to track your ride in real-time for a seamless travel experience."
    },
    {
        "WhyChooseheading": "Safe, Clean, and Sanitized Rides",
        "WhyChoosedescription": "We prioritize your safety and comfort. All our vehicles are thoroughly cleaned and sanitized after each ride, and our drivers follow strict safety protocols. With Skyline Cabs, you can rest assured that you’re traveling in a safe and hygienic environment."
    },
    {
        "WhyChooseheading": "Flexible Vehicle Options for All Groups",
        "WhyChoosedescription": "Whether you’re traveling solo, with family, or in a group, Skyline Cabs offers a variety of vehicles to match your needs. From compact sedans for individual travelers to spacious SUVs for larger groups, we have the perfect vehicle for your Jogeshwari to Pune journey."
    }
]
























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Jogeshwari to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Jogeshwari to Pune is simple. You can either book online through our website or mobile app, or you can call our customer service team for assistance. Just select your pickup and drop-off locations, choose your vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What vehicles are available for Jogeshwari to Pune travel?',
            answer:
                'We offer a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle that best suits your travel needs based on the number of passengers and comfort preferences.',
        },
        {
            id: 3,
            question: 'What is the estimated travel time from Jogeshwari to Pune?',
            answer:
                'The travel time from Jogeshwari to Pune typically ranges between 3.5 to 5 hours depending on the traffic conditions. Our drivers are experienced and will ensure a smooth and timely ride.',
        },
        {
            id: 4,
            question: 'Is the fare for Jogeshwari to Pune cab fixed?',
            answer:
                'Yes, the fare is fixed and includes all charges such as tolls, taxes, and driver fees. You can check the fare estimate online before confirming your booking to ensure complete transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Jogeshwari to Pune?',
            answer:
                'Yes, you can easily book a round-trip cab. Just provide your return trip details when you make your booking, and we’ll arrange for your return journey as well.',
        },
        {
            id: 6,
            question: 'Do you offer cab services for both business and leisure travel?',
            answer:
                'Yes, whether you’re traveling for business or leisure, we provide comfortable, safe, and punctual cab services. We also offer corporate travel packages tailored to your needs.',
        },
        {
            id: 7,
            question: 'Can I make changes to my booking after confirming?',
            answer:
                'Yes, you can modify or cancel your booking through our website or mobile app. Our customer support is also available to assist you in case of any last-minute changes.',
        },
        {
            id: 8,
            question: 'Is the driver for Jogeshwari to Pune journey professional?',
            answer:
                'All our drivers are highly professional, well-trained, and verified. They ensure safe driving and follow the best routes to make your journey comfortable and on time.',
        },
        {
            id: 9,
            question: 'Are the vehicles well-maintained for the journey?',
            answer:
                'Yes, all our vehicles are well-maintained, clean, and equipped with essential amenities to ensure a comfortable ride. We regularly service our vehicles to ensure they are in top condition.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Jogeshwari to Pune trip?',
            answer:
                'Skyline Cabs offers reliable, affordable, and high-quality cab services. With professional drivers, transparent pricing, and well-maintained vehicles, we ensure a hassle-free and enjoyable journey from Jogeshwari to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sanjay Mehta",
            rating: 5,
            review: "I frequently travel from Jogeshwari to Pune for business meetings. Skyline Cabs has always been my go-to option due to their punctuality and comfort. The vehicles are clean, and the drivers are always professional. Highly recommend!"
        },
        {
            name: "Miss. Aditi Kapoor",
            rating: 4,
            review: "Booked a cab from Jogeshwari to Pune for a weekend getaway. The ride was smooth, and the driver was friendly. I appreciated the timely service and cleanliness of the car. Would definitely use Skyline Cabs again for my trips!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Jogeshwari to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/jogeshwari-to-pune-cab.jpg",
  "description": "Book Jogeshwari to Pune cabs with Skyline Cabs for a smooth, safe, and affordable journey. Choose from AC sedans or SUVs with professional drivers—available 24/7 for one-way or round-trip rides.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7683"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/jogeshwari-to-pune-cabs"
  }
};



      
    

    return (
        <div>

<Helmet>
  <title>Jogeshwari to Pune Cabs | 24x7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Jogeshwari to Pune cabs with Skyline Cabs for a smooth, safe, and affordable journey. Choose from AC sedans or SUVs with professional drivers—available 24/7 for one-way or round-trip rides." 
  />
  <meta 
    name="keywords" 
    content="Jogeshwari to Pune Cabs, Cab from Jogeshwari to Pune, One-Way Taxi Jogeshwari to Pune, Round Trip Cab Jogeshwari to Pune, AC Cab Jogeshwari to Pune, SUV Taxi Jogeshwari to Pune, Online Cab Booking Jogeshwari to Pune, Affordable Cabs Jogeshwari to Pune, 24/7 Taxi Jogeshwari to Pune, Skyline Cabs Jogeshwari to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/42.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Jogeshwaritopunecab;